import http from "../http-common";

class LogService {
  // Create an agency
  create(data) {
    console.log("log.service.create# ", data)
    return http.post(`/logging/`, data);
  }
}

export default new LogService();

